export { CampaignAttemptStatus } from './generated/CampaignAttemptStatus.js';